const translations = {
  "en": {
    "%{var0} Forecast": "%{var0} Forecast",
    "Please retry after the current response completes": "Please retry after the current response completes",
    "Swap": "Swap",
    "View Detail": "View Detail"
  },
  "zh-tw": {
    "%{var0} Forecast": "%{var0} 預測",
    "Please retry after the current response completes": "請在目前的回應完成後再重試",
    "Swap": "兌換",
    "View Detail": "查看細節"
  }
};

export default translations;
